export default "__VITE_ASSET__NiJdN1Oo__"